<template>
    <div>
       <van-empty image="error"   >
           <template #description>
               <p>账户访问异常，请联系客服 <a href="tel:4008812336" >400-8812-336</a></p>

           </template>
       </van-empty>
    </div>
</template>
<script>
/*global $ */
export default {
    mounted(){
        $('.footer').hide();
    }
}
</script>
<style lang="less" scoped>
/deep/ .van-empty__description{
    padding:0px 45px;
    a{
        color: #969799;
    }
}
</style>